// @flow

// eslint-disable-next-line project-structure/folder-structure
import reisegeierLogo from 'assets/images/logo-reisegeier.svg';
import * as confirmation from 'config/reisegeier-ch/confirmation.json';
import * as footer from 'config/reisegeier-ch/footer.json';
import * as googleMaps from 'config/reisegeier-ch/googleMaps.json';
import * as htmlHeadAttributes from 'config/reisegeier-ch/htmlHeadAttributes.json';
import * as reservation from 'config/reisegeier-ch/reservation.json';
import * as service from 'config/reisegeier-ch/service.json';
import * as topHotels from 'config/reisegeier-ch/topHotels.json';
import * as voucherConditions from 'config/reisegeier-ch/voucherConditions.json';

export default {
  description: htmlHeadAttributes.default.description,
  confirmation: confirmation.default,
  footer: footer.default,
  reservation: reservation.default,
  service: service.default,
  voucherConditions: voucherConditions.default,
  topHotels,
  logo: reisegeierLogo,
  googleMaps: googleMaps.default,
};
